/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * フォントファミリー
 * @export
 */
export const FontFamily = {
    Gothic: 'gothic',
    Mincho: 'mincho',
    Monospace: 'monospace'
};
export function FontFamilyFromJSON(json) {
    return FontFamilyFromJSONTyped(json, false);
}
export function FontFamilyFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FontFamilyToJSON(value) {
    return value;
}
